import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from 'mui-datatables';
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {
  getStudentPrograms,
  agreementAllDetails,
} from 'Actions';
import Selectsearch from "react-select";
import {
    FormGroup,
    Label,

} from 'reactstrap';

class AgreementProgram extends Component {
constructor(props) {
  super(props);
  this.state = {
    viewdiv: false,
    selectedProgram: '',
  };
}

UNSAFE_componentWillMount() {
  this.props.agreementAllDetails();
}

handleChange = (selectedOption) => { 
  if (selectedOption) {
    this.props.getStudentPrograms(selectedOption.value)
      .then(() => {
        this.setState({ viewdiv: true, selectedProgram: selectedOption.value });
      })
  }
}

render() {
  const { contractagreementlist, program, loading } = this.props;
  const options = {
    filterType: 'dropdown',
    rowsPerPage: 50,
    responsive:'standard',
    rowsPerPageOptions: [50, 100, 150],
    selectableRowsHideCheckboxes: true,
  };

  const columns = [
    { name: 'sno', label: 'SNO.' },
    { name: 'student', label: 'STUDENT' },
  ];

  const tableData = contractagreementlist
    ? contractagreementlist.map((data, index) => ({
        sno: index + 1,
        student: data.studentname,
      }))
    : [];

    return (
      <div className="tab-pane fade active show" id="tabs-text-5" role="tabpanel" aria-labelledby="tabs-text-5-tab">
         <div className="row">
          <div className="form-group col-sm-12 col-xl-4" style={{margin:"0 auto", marginBottom:"30px"}}>
          <label className="form-control-label" htmlFor="input-username">Select Program </label>
          <FormGroup>
              <Label for="Select" style={{ fontWeight: "bold" }}>Select Program</Label>
              <Selectsearch
                id="programid"
                name="programid"
                options={program.map(p => ({ value: p.id, label: p.name }))}
                value={program.find(obj => obj.value === this.state.selectedProgram)}
                onChange={this.handleChange}
                required
              />
            </FormGroup>
        </div>
        </div>
        <div className="row">
        {this.state.viewdiv && contractagreementlist && (
          <div className="col-sm-12 col-lg-5" style={{margin:"0 auto"}}>
            <MUIDataTable
              data={tableData}
              columns={columns}
              options={options}
            />
          </div>
        )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const { contractDashboard, contractstudent } = state;
  return {
    contractagreementlist: contractDashboard.contractagreementlist,
    program:contractstudent.allgolfprogram,
    loading: contractDashboard.loading,
  };
};

export default connect(mapStateToProps, {getStudentPrograms,agreementAllDetails})(AgreementProgram);
